<template>
  <div class="relative mb-2"
    v-outside-click="{
      exclude: [],
      handler: 'closeDropdown'
    }">
    <label class="font-bold mb-1 block">{{ text }}</label>
    <div class="relative inline-block">
      <input v-if="checkBox == true"
        v-model="checkBoxSelected"
        type="checkbox"
        class="form-checkbox my-2.5 h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
        @change="toggleSelected"
      />
      <button v-else 
        :class="['cursor-pointer py-2 px-2 border border-gray-300 bg-white rounded-xl text-left flex justify-between items-center',
                  name === 'district' ? 'w-96' : name === 'direction' ? 'w-46' : 'w-64']"
        @click="toggleDropdown">
        {{ dropdownText }}
        <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      <div class="absolute top-full left-0 z-50 w-full min-w-64 p-2 mt-1 bg-white border border-gray-300 rounded-md shadow-lg" :class="{ 'block': isOpen, 'hidden': !isOpen }">
        <div v-if="name === 'district'" class="px-4 py-2">
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Search districts..."
            class="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>
        <div class="max-h-80 overflow-y-auto">
          <label v-for="(option, index) in filteredOptions" :key="index" class="flex items-center px-4 py-2 whitespace-nowrap">
            <input
              type="checkbox"
              :value="getOptionValue(option)"
              v-model="selected"
              @change="handleChange"
              class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
            />
            <span class="ml-2">{{ optionDisplayText(option) }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import events from '../services/events.js'

export default {
  props: {
    name: String,
    text: String,
    placeholderText: String,
    selectedFilter: Array,
    filterOptions: Array,
    checkBox: {
      type: Boolean,
      default: false,
    },
    optionDisplay: {
      type: String,
      default: 'display',
    },
  },
  data() {
    return {
      selected: [],
      isOpen: false,
      searchQuery: '',
      checkBoxSelected: false,
    }
  },
  computed: {
    filteredOptions() {
      if (this.searchQuery === '') {
        return this.filterOptions
      }
      const lowerSearchQuery = this.searchQuery.toLowerCase()
      return this.filterOptions.filter(option => {
        const optionText = this.optionDisplayText(option).toLowerCase()
        return optionText.includes(lowerSearchQuery)
      })
    },
    dropdownText() {
      if (this.selected.length === 0) {
        return `Select ${this.text}`
      } else if (this.selected.length === 1) {
        const selectedOption = this.filterOptions.find(option => this.getOptionValue(option) === this.selected[0])
        return this.optionDisplayText(selectedOption)
      } else {
        return `${this.selected.length} options selected`
      }
    },
  },
  eventCallbackIds: {},
  methods: {
    resetSelection() {
      this.selected = []
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
    },
    toggleSelected() {
      if (this.selected[0] === true) {
        this.selected = []
        this.checkBoxSelected = false
      } else if (this.selected[0] === false || this.selected.length === 0) {
        this.selected = [true]
        this.checkBoxSelected = true
      } 
      this.handleChange()
    },
    handleChange() {
      this.$emit('setSelectedFilter', this.selected)
    },
    optionDisplayText(option) {
      if (this.name === 'district') {
        return `${option.name} (${option.code})`
      }
      if (this.name === 'vendor') {
        return `${option.name} (${option.partition.description})`
      }
      return option[this.optionDisplay]
    },
    getOptionValue(option) {
      if (this.name === 'district' || this.name === 'partition' || this.name === 'vendor' || this.name === 'vehicle') {
        return option.id
      } else {
        return option.code
      }
    },
  },
  watch: {
    selectedFilter(newValue) {
      if (newValue) {
        this.$set(this, 'selected', newValue)
      }
      else {
        this.selected = []
      }

      if (this.checkBox) {
        this.checkBoxSelected = !!newValue
      }
    },
  },
  created() {
    this.selected = this.selectedFilter || []
    this.$options.eventCallbackIds.clearFilters = events.register('clearFilters', this.resetSelection)
  },
  beforeDestroy() {
    events.remove('clearFilters', this.$options.eventCallbackIds.clearFilters)
  }
}
</script>
